import { WEB_URL } from "@/config/endpoints";
import { convertToIST } from "@/lib/istTime";
import IMAGES from "@/public/assets/img";
import { useRouter } from "next/router";


export const generateBlogSchema = (post,locale,description,minutes) => {
    if (!post) return {};

    const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '';
    const publishedDate = convertToIST(post.date);
    const modifiedDate = convertToIST(post.modified);
    const pageUrl = `${WEB_URL}${locale === 'es-mx' ? '/es-mx/blogs/' : '/blogs/'}${post.slug}`;
    const authorData = post._embedded.author[0];
    const linkedInUrl = authorData.yoast_head_json.schema["@graph"][3].sameAs.find(url => url.includes('linkedin.com'));
    const authorProfileImage = authorData.yoast_head_json.schema["@graph"][3].sameAs[1] || '';
    const authorDesignation = (authorData.yoast_head_json.schema["@graph"][3].sameAs[2] || '').replace(/, Credlix$/, '');
    const authorPageURL = `${WEB_URL}${locale === 'es-mx' ? '/es-mx/author/' : '/author/'}${authorData.slug}`;
   // Define the author object conditionally
    let author;
    if (authorData.name === 'admin') {
      author = {
        "@type": "Organization",
        "name": "Credlix",
      };
    } else {
      author = {
        "@type": "Person",
        "@id": authorPageURL,
        "name": authorData.name,
        "jobTitle": authorDesignation,
        "description": authorData.description,
        "image": authorProfileImage,
        "worksFor": {
          "@type": "Organization",
          "name": "Credlix"
        },
        "sameAs": [
          linkedInUrl
        ]
      };
    }

    return { 
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "headline": post.title.rendered,
      "description": description,
      "url": pageUrl,
      "image": {
        "@type": "ImageObject",
        "url": featuredImage,
        "width": 828,
        "height": 553
      },
      "datePublished":publishedDate,
      "dateModified": modifiedDate,
      "author": author,
     "inLanguage": locale,
     ...(minutes > 0 && { "timeRequired": `PT${minutes}M` }),
      "publisher": {
        "@type": "Organization",
        "name": "Credlix",
        "url": WEB_URL,
        "logo": {
          "@type": "ImageObject",
          "url":WEB_URL+IMAGES.SHARED.credlixLogo.src,
          "width": 170,
          "height": 48
        }
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": pageUrl
      }

    };
  }
